import Vue from 'vue'
import VueRouter from 'vue-router'
import 'modern-css-reset'

Vue.use(VueRouter)

const animDelay = (className, delay) => {
  const el = document.querySelector(className) 
  el.style.cssText = `transition-delay: ${delay}ms`
  setTimeout(() => { el.style.cssText = '' }, delay)
}

const routes = [
  {
    path: '/',
    name: 'Home',
  },
  {
    path: '/forecast',
    name: 'Forecast',
  },
  {
    path: '/accumulation',
    name: 'Accumulation',
  },
  {
    path: '*', redirect: "/",
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Forecast') {
    if (from.name === 'Home') {
      animDelay('.forecast', 500)
      animDelay('.accumulation', 500)
    }
  }
  if (to.name === 'Home') {
    if (from.name === 'Forecast') {
      animDelay('.Description', 500)
      animDelay('.nav-container', 200)
    }
  }
  next()
})

export default router
